/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useParams } from 'react-router-dom';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useGetSportTroubleshootingMutation } from '../../../../services/sportService/sportService';
import Strings from '../../../../i18n';
import { utcToBrowserDate } from '../../../../utils/date';

const SentAtCell = ({
  executed,
  executedAt
}: {
  executed: boolean;
  executedAt: string;
}) => {
  if (!executed && executedAt?.length) {
    return <ReportProblemIcon />;
  }
  return <>{utcToBrowserDate(executedAt, 'hh:mm:ss A')}</>;
};

export const SportTroubleShootingTemplate = () => {
  const { locationId } = useParams();
  const [getSportTroubleshooting, { isLoading, data }] =
    useGetSportTroubleshootingMutation();

  const [dateExecuteAtStart, setDateExecuteAtStart] = useState<Date>(
    new Date()
  );
  const [dateExecuteAtEnd, setDateExecuteAtEnd] = useState<Date>(
    new Date(new Date().setDate(new Date().getDate() + 2))
  );

  useEffect(() => {
    if (locationId) {
      getSportTroubleshooting({
        locationId: Number(locationId),
        dateExecuteAtStart: dateExecuteAtStart.toISOString(),
        dateExecuteAtEnd: dateExecuteAtEnd.toISOString()
      });
    }
  }, []);

  return (
    <div className="row">
      <div className="col-12 justify-content-around d-flex mt-3 mb-2">
        <div className="flex-auto">
          <label htmlFor="dateExecuteAtStart" className="font-bold block mr-2">
            From:
          </label>
          <Calendar
            id="dateExecuteAtStart"
            value={dateExecuteAtStart}
            onChange={(e) => setDateExecuteAtStart(e.value ?? new Date())}
            showIcon
            maxDate={dateExecuteAtEnd}
          />
        </div>
        <div className="flex-auto">
          <label htmlFor="dateExecuteAtEnd" className="font-bold block mr-2">
            To:
          </label>
          <Calendar
            id="dateExecuteAtEnd"
            value={dateExecuteAtEnd}
            onChange={(e) => setDateExecuteAtEnd(e.value ?? new Date())}
            showIcon
            minDate={dateExecuteAtStart}
          />
        </div>
        <Button
          onClick={() =>
            getSportTroubleshooting({
              locationId: Number(locationId),
              dateExecuteAtStart: dateExecuteAtStart.toISOString(),
              dateExecuteAtEnd: dateExecuteAtEnd.toISOString()
            })
          }
        >
          {isLoading ? Strings.common.loading : Strings.common.typeToSearch}
        </Button>
      </div>
      <div className="col-12">
        <DataTable
          value={data}
          scrollable
          scrollHeight="flex"
          size="small"
          rowHover
          tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
        >
          <Column field="teamName" header="Team" />
          <Column
            field="gameDate"
            header="Game Start"
            body={(row) =>
              utcToBrowserDate(row.gameDate, 'MMM DD YYYY, hh:mm A')
            }
          />
          <Column field="preferenceName" header="Preference Name" />
          <Column
            field="executeAt"
            header="Schedule for"
            body={(row) => utcToBrowserDate(row.executeAt, 'hh:mm:ss A')}
          />
          <Column
            field="sportsEventsDeferred"
            header="Event Override"
            body={(row) => (row.sportsEventsDeferred ? Strings.common.yes : '')}
          />
          <Column
            field="enabled"
            header="Enabled"
            body={(row) =>
              row.enabled ? Strings.common.yes : Strings.common.no
            }
          />
          <Column field="status" header="Status" />
          <Column
            field="executed"
            header="Executed"
            body={(row) =>
              row.executed ? Strings.common.yes : Strings.common.no
            }
          />
          <Column header="Sent At" field="executedAt" body={SentAtCell} />
        </DataTable>
      </div>
    </div>
  );
};
